// src/components/CustomCursor.jsx
import React, { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const DOT_SIZE = 14;
const LOUPE_SIZE = 220;
const LOUPE_MORPH_SCALE = LOUPE_SIZE / DOT_SIZE;

const cursorMorphTransition = {
  duration: 0.35,
  ease: [0.33, 1, 0.68, 1],
};

const CustomCursor = ({ showLoupe, showSecret, showView }) => {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);

  const springX = useSpring(x, { stiffness: 300, damping: 25, mass: 0.4 });
  const springY = useSpring(y, { stiffness: 300, damping: 25, mass: 0.4 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };

    window.addEventListener("pointermove", move);
    return () => window.removeEventListener("pointermove", move);
  }, [x, y]);

  return (
    <>
      {/* cursor dot – morphs into loupe in Expertise section */}
      <motion.div
        className="cursor-dot"
        style={{
          x: springX,
          y: springY,
          translateX: "-50%",
          translateY: "-50%",
        }}
        initial={false}
        animate={{
          opacity: showLoupe ? 0 : 1,
          scale: showLoupe ? LOUPE_MORPH_SCALE : 1,
        }}
        transition={cursorMorphTransition}
      />

      {/* loupe – Swiss army knife / Expertise section */}
      <motion.div
        className="cursor-loupe"
        style={{
          x: springX,
          y: springY,
          translateX: "-50%",
          translateY: "-50%",
        }}
        initial={false}
        animate={{
          opacity: showLoupe ? 1 : 0,
          scale: showLoupe ? 1 : 1 / LOUPE_MORPH_SCALE,
        }}
        transition={cursorMorphTransition}
      >
        <motion.span
          className="cursor-loupe-secret"
          initial={false}
          animate={{
            opacity: showSecret ? 1 : 0,
            y: showSecret ? 0 : 6,
          }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          YOU FOUND ME! :)
        </motion.span>
      </motion.div>

      {/* VIEW label for case study cards */}
      <motion.div
        className="cursor-view-label"
        style={{
          x: springX,
          y: springY,
          translateX: "-50%",
          translateY: "-50%",
        }}
        initial={false}
        animate={{
          opacity: showView ? 1 : 0,
          scale: showView ? 1 : 0.85,
        }}
        transition={{ duration: 0.18, ease: "easeOut" }}
      >
        VIEW
      </motion.div>
    </>
  );
};

export default CustomCursor;
